<template>
  <div style="background: #f5f5f5 !important">
    <div class="title-section" style="display: flex">
      <h1 class="title title-ruban">INSCRIPTION</h1>
    </div>
    <div class="page-seperate"></div>

    <div class="columns is-mobile is-centered">
      <div class="column is-one-quarter">
        <div class="has-text-right" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'login' }"> Déjà inscrit?</router-link>
        </div>
        <div class="has-text-right" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'lostPassword' }"
            >Mot de passe oublié?</router-link
          >
        </div>
        <div v-if="error" class="alert alert-danger">{{ error }}</div>
        <form action="#" @submit.prevent="register" custom-class="required">
          <b-field label="Nom" required>
            <b-input
              type="text"
              v-model="form.name"
              ref="name"
              class="full-width"
              required
            />
          </b-field>
          <b-field label="Email">
            <b-input
              type="email"
              v-model="form.email"
              ref="email"
              class="full-width"
              required
            />
          </b-field>

          <b-field label="Mot de passe" required>
            <b-input
              type="password"
              v-model="form.password"
              ref="password"
              password-reveal
              required
            />
          </b-field>

          <b-button
            native-type="submit"
            name="button  "
            class="is-info"
            style="
              margin-left: 50%;
              margin-right: 0%;
              margin-top: 1rem;
              margin-bottom: 0.5rem;
            "
            :loading="isLoading"
          >
            S'inscrire
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { onUserLogged } from "../../services/dbService";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
      },
      error: null,
      isLoading: false,
    };
  },
  methods: {
    register() {
      this.isLoading = true;
      const auth = getAuth();
      const firebaseErrors = {
        "auth/user-not-found": "Utilisateur ou mot de passe incorrect",
        "auth/email-already-in-use": "Compte utilisateur déjà existant",
      }; // list of firebase error codes to alternate error messages
      createUserWithEmailAndPassword(auth, this.form.email, this.form.password)
        .then(async (userCreditential) => {
          updateProfile(userCreditential.user, {
            displayName: this.form.name,
          }).then(() => {
            // this.$store.dispatch("fetchUser", userCreditential.user);
          });
          onUserLogged(userCreditential.user).then((is_su) => {
            // mise à jour des varaible hasResult/hasSurvey pour le dashboard
            this.$store.dispatch("updateUserDashboard").then(() => {
              this.$nextTick(() => {
                if (is_su == true) this.$router.push({ name: "Campaigns" });
                else this.$router.push({ name: "Dashboard" });
              });
            });
          });
        })
        .catch((err) => {
          console.log(err);
          // si l'utilisateur existe déjà on essai de se connecter
          if (err.code == "auth/email-already-in-use") {
            signInWithEmailAndPassword(auth, this.email, this.password)
              .then((userCreditential) => {
                onUserLogged(userCreditential.user).then(async (is_su) => {
                  //  var suResult = await isSu(userCreditential.user);
                  // this.$store.dispatch("updateIsSu", suResult).then(() => {
                  // mise à jour des varaible hasResult/hasSurvey pour le dashboard
                  this.$store.dispatch("updateUserDashboard").then(() => {
                    this.$nextTick(() => {
                      if (is_su == true)
                        this.$router.push({ name: "Campaigns" });
                      else this.$router.push({ name: "Dashboard" });
                    });
                  });
                  //  });
                });
              })
              .catch((err) => {
                this.error = firebaseErrors[err.code] || err.message;
                this.isLoading = false;
                this.$buefy.snackbar.open({
                  message: firebaseErrors[err.code] || err.message,
                  type: "is-warning",
                  queue: false,
                });
              });
          } else {
            this.error = firebaseErrors[err.code] || err.message;
            this.isLoading = false;
            this.$buefy.snackbar.open({
              message: firebaseErrors[err.code] || err.message,
              type: "is-warning",
              queue: false,
            });
          }
        });
    },
  },
};
</script>
